import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

const toNumber = (v) =>
  Number(
    String(v ?? "")
      .replace(/\./g, "")
      .replace(",", ".")
  ) || 0;

const toInput = (n) => (Number(n) || 0).toFixed(2).replace(".", ",");

const formatBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    Number(v) || 0
  );

/**
 * Modal de fechamento do pedido de venda (abre ao mudar o status para Entregue).
 * Peso x valor unitário = novo valor final a receber. O valor total dos
 * produtos não é alterado; o pai atualiza o Total Final e as contas a receber.
 */
export default function FechamentoPedidoModal({
  open,
  pesoInicial,
  unitarioInicial,
  totalAtual,
  onCancel,
  onApply,
}) {
  const [peso, setPeso] = useState("");
  const [unitario, setUnitario] = useState("");

  useEffect(() => {
    if (open) {
      setPeso(toInput(pesoInicial));
      setUnitario(toInput(unitarioInicial));
    }
  }, [open, pesoInicial, unitarioInicial]);

  const valorFinal = toNumber(peso) * toNumber(unitario);

  return (
    <Dialog open={open} onClose={onCancel} sx={{ zIndex: 10000 }}>
      <DialogTitle>Fechamento do pedido</DialogTitle>
      <DialogContent>
        <Typography variant="body2" mb={2}>
          Informe o peso e o valor unitário do fechamento. O valor final a
          receber e as contas a receber em aberto serão recalculados. O valor
          total dos produtos não muda.
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Peso"
              value={peso}
              onChange={(e) => setPeso(e.target.value.replace(/[^\d,]/g, ""))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Valor unitário (R$)"
              value={unitario}
              onChange={(e) =>
                setUnitario(e.target.value.replace(/[^\d,]/g, ""))
              }
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
        </Grid>
        <Typography variant="body2" mt={2}>
          Total final atual: <b>{formatBRL(totalAtual)}</b>
        </Typography>
        <Typography variant="body1" mt={1}>
          Novo valor final a receber: <b>{formatBRL(valorFinal)}</b>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Manter valores atuais</Button>
        <Button
          variant="contained"
          sx={{ color: "white !important" }}
          disabled={!(valorFinal > 0)}
          onClick={() =>
            onApply({
              peso: toNumber(peso),
              valorUnitario: toNumber(unitario),
              valorFinal,
            })
          }
        >
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
